var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9782 7.5C25.0239 7.50562 27.6402 7.53 30.4211 7.63687L31.4081 7.67812C34.2065 7.80375 37.003 8.02125 38.3915 8.39062C40.2421 8.88937 41.6952 10.3406 42.1867 12.1819C42.9701 15.1069 43.068 20.8106 43.0797 22.1925L43.0817 22.4775V22.8037C43.068 24.1856 42.9701 29.8912 42.1867 32.8144C41.6893 34.6612 40.2343 36.1144 38.3915 36.6056C37.003 36.975 34.2065 37.1925 31.4081 37.3181L30.4211 37.3612C27.6402 37.4662 25.0239 37.4925 23.9782 37.4962L23.518 37.4981H23.0186C20.8057 37.485 11.5506 37.3894 8.60524 36.6056C6.75658 36.1069 5.30153 34.6556 4.80999 32.8144C4.02666 29.8894 3.92874 24.1856 3.91699 22.8037V22.1925C3.92874 20.8106 4.02666 15.105 4.80999 12.1819C5.30741 10.335 6.76245 8.88187 8.6072 8.3925C11.5506 7.60687 20.8076 7.51125 23.0205 7.5H23.9782ZM19.5817 15.9375V29.0625L31.3317 22.5L19.5817 15.9375Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.81751a4354e09d37deec015828284fc5.svg";
export { ForwardRef as ReactComponent };